/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ActivityResponse } from '../../models/activity-response';

export interface GetRandomActivities$Params {
  count: number;

/**
 * If set to TRUE than returned are only ongoing activities.
 */
  ongoingOnly: boolean;
}

export function getRandomActivities(http: HttpClient, rootUrl: string, params: GetRandomActivities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ActivityResponse>>> {
  const rb = new RequestBuilder(rootUrl, getRandomActivities.PATH, 'get');
  if (params) {
    rb.path('count', params.count, {});
    rb.query('ongoingOnly', params.ongoingOnly, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ActivityResponse>>;
    })
  );
}

getRandomActivities.PATH = '/rest/activity/get-random/{count}';
